import {useState, useEffect} from 'react'

export default function useAgeGate(
  enabled,
  waitUntilTrue,
  redirectAfterAgeGate,
) {
  const [age, setAge] = useState()

  function handleAtLeast21() {
    setAge('atLeast21')
    localStorage.setItem('age', 'atLeast21')
    if (redirectAfterAgeGate) redirectAfterAgeGate()
  }

  function handleNot21() {
    setAge('not21')
  }

  return {age, setAge, handleAtLeast21, handleNot21}
}
